var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Export',{attrs:{"date_filter":false,"entities":_vm.entities,"title":'Grade Statuses',"course_filter":true,"semesters":_vm.semesters,"grade_status_filter":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }